"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebFile = void 0;
/**
 * WebFile implements the FileI interface for web browsers.
 * It wraps a standard File object and provides a bytes method that returns the file content as a Uint8Array.
 */
class WebFile {
    /**
     * Creates a new WebFile instance.
     * @param file The standard File object to wrap
     */
    constructor(file) {
        this.file = file;
    }
    /**
     * Gets the name of the file.
     */
    get name() {
        return this.file.name;
    }
    /**
     * Gets the file content as a Uint8Array.
     * This implementation uses ArrayBuffer for performance in web environments.
     * @returns Promise resolving to a Uint8Array containing the file's binary data
     */
    async bytes() {
        // Read the file as an ArrayBuffer
        const arrayBuffer = await this.file.arrayBuffer();
        // Convert ArrayBuffer to Uint8Array
        return new Uint8Array(arrayBuffer);
    }
}
exports.WebFile = WebFile;
